'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-341/node_modules/@eliadmin/core/src/components/wholesale/wholesale-form.tsx";
export { wholesalerSchema } from "@eliadmin/core/src/components/wholesale/wholesale-schema";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-341/node_modules/@eliadmin/core/src/components/wholesale/wholesale-form.tsx").WholesaleForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/wholesaleForm").then(m => ({ default: m.WholesaleForm })));
export function WholesaleForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

